import React from "react";

import { Gallery } from "../components/Gallery";

export const MerchPage = () => {
  return <Gallery filter="merch" />;
};
